import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Card from '../../../Card';

import { ImageCardSkeletonProps } from './ImageCardSkeleton.types';

import './ImageCardSkeleton.scss';

const ImageCardSkeleton: React.FC<ImageCardSkeletonProps> = ({
  className
}) => {
  return (
    <Card className={`relative flex flex-column p4 ${className}`}>
      <Skeleton variant="rect" className="br2 image-skeleton" />
    </Card>
  );
};

export default ImageCardSkeleton;
export { ImageCardSkeletonProps };
